import {EAdminStatus, Order} from 'src/app/models'

export enum EOrganizationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export interface IOrganization {
  id: string
  name: string
  code: string
  first_name: string
  last_name: string
  account_quota: number
  total_accounts: number
  pic_email: string
  pic_name: string
  internal_notes: string
  status: keyof typeof EOrganizationStatus
}

export interface IOrganizationDetail {
  id: string
  code: string
  name: string
  pic_email: string
  pic_status?: keyof typeof EAdminStatus
  pic_id?: string
  first_name: string
  last_name: string
  company_description: string
  internal_notes: string
  logo?: string
  account_quota: number
  total_accounts: number
  status: keyof typeof EOrganizationStatus
  is_active: boolean
  companies?: {
    code?: string
    id?: string
    is_active?: boolean
    name?: string
    departments?: {
      code?: string
      id?: string
      is_active?: boolean
      name?: string
    }[]
  }[]
}

export interface IOrganizationQuery {
  search?: string
  page?: number
  size?: number
  sort?: string
  order?: Order
  status?: keyof typeof EOrganizationStatus
}

export interface IFormValuesOrganization {
  name: string
  code: string
  logo: string
  logo_preview: string
  first_name: string
  last_name: string
  admin_email: string
  internal_notes: string
  is_active: boolean
  account_quota: string | number
  total_accounts: string | number
}
